import vehicleAccident from "../constant/accidentConstant";
import {
  API_STATUS,
  GET_COUNT_TYPE,
  ORG_ID,
  QUESTION_ANSWER_RESPONSE_TYPE,
  QUESTION_RESPONSE_TYPE_VALUE,
} from "../constant/constant";
import { getInspectionViolationCounts } from "../services/incpectionService";
import { getFormatedDate } from "./helper";
import { checkPrivileges } from "./rolesHelper";

const HBNUser = checkPrivileges([12, 139, 144]);

const cleanQuill = (html) =>
  typeof html === "string" ? html.replace(/<p><br><\/p>/gi, "").trim() : "";

const isTruthy = (v) =>
  !(v === undefined || v === null || `${v}`.trim?.() === "");

// ---------- UPDATED isAnswered: treat N/A (radio value 3) as answered ----------
const isAnswered = (q) => {
  const rt = parseInt(q.responsetype);
  if (rt === 1) return parseInt(q.radioSelectiovalue) > 0; // Acceptable(1)/NotAcceptable(2)/N/A(3) all count
  if (rt === 2) return cleanQuill(q.textAreaDetail || "") !== "";
  if (rt === 3) return Number.parseInt(q.singleSelect) > 0;
  if (rt === 4) return Array.isArray(q.multiSelect) && q.multiSelect.length > 0;
  return false;
};

const nonSkipped = (subs) => (subs || []).filter((sc) => !sc.isSkipped);

export function recomputeSubProgress(subCategory) {
  const qs = subCategory?.listInspectionQuestionAnswer || [];

  if (subCategory?.isSkipped) {
    subCategory.subPercent = qs.length ? 100 : 0;
    subCategory.howManySub = qs.length;
    subCategory.isAnswerCat = true;
    subCategory.subCatAns = true;
    return;
  }

  const mandatoryQs = qs.filter((q) => q.isMandatory);

  const totalMandatory = mandatoryQs.length;

  if (totalMandatory === 0) {
    subCategory.subPercent = 100;
    subCategory.howManySub = qs.length;
    subCategory.isAnswerCat = true;
    subCategory.subCatAns = true;
    return;
  }

  const answeredMandatory = mandatoryQs.filter((q) => isAnswered(q)).length;
  subCategory.subPercent = (100 * answeredMandatory) / totalMandatory;

  subCategory.howManySub = answeredMandatory;

  const isCompleted = answeredMandatory === totalMandatory;

  subCategory.isAnswerCat = isCompleted;
  subCategory.subCatAns = isCompleted;
}

export function recomputeCategoryProgress(category) {
  const subs = category?.listInspectionSubCategory || [];

  if (subs.length === 0) {
    category.catPercent = 100;
    category.howManyCat = 0;
    category.catAns = true;
    return;
  }

  const completedSubs = subs.filter(
    (sc) => sc.isSkipped || sc.isAnswerCat === true,
  ).length;

  category.catPercent = (100 * completedSubs) / subs.length;

  category.howManyCat = completedSubs;
  category.catAns = completedSubs === subs.length;
}

export const listInspectionCategoryObject = (data) => {
  return data?.map((categoryItem) => {
    return {
      key: categoryItem.key,
      value: categoryItem.value,
      catPercent: 0,
      howManyCat: 0,
      catAns: false,
      catError: false,
      sequenceNumber: categoryItem.sequenceNumber,
      isSkippable: categoryItem?.isSkippable,
      isSkipped: categoryItem?.isSkippable === false ? null : false,
      listInspectionSubCategory: categoryItem.subcategories?.map(
        (subCategoryItem) => {
          return {
            key: subCategoryItem.key,
            isAnswerCat: false,
            subCatError: false,
            howManySub: 0,
            value: subCategoryItem.value,
            subPercent: 0,
            sequenceNumber: subCategoryItem.sequenceNumber,
            showBth: subCategoryItem.questions.some(
              (findItem) => !findItem.isTextResponse,
            ),
            isSkippable: subCategoryItem?.isSkippable,
            isSkipped: subCategoryItem?.isSkippable === false ? null : false,
            subCatAns: false,
            listInspectionQuestionAnswer: subCategoryItem.questions
              ?.filter((x) => x.isSelected)
              ?.map((questionItem) => {
                const dataForm = {
                  acceptable: [
                    {
                      id: Date.now() + Math.floor(Math.random() * 100),
                      comment: "",
                      files: "",
                      media: [],
                      involdevPaty: "N/A",
                      employee: [],
                      employeeCurrent: "",
                      subcontractor: [],
                      subcontractorCurrent: "",
                      projectReq: "",
                    },
                  ],
                  notacceptable: [
                    {
                      id: Date.now() + Math.floor(Math.random() * 100),
                      comment: "",
                      involdevPaty: "N/A",
                      employee: [],
                      employeeCurrent: "",
                      subcontractor: [],
                      subcontractorCurrent: "",
                      escalatetoreprimandIsChecked: "No",
                      escalatetoreprimandComment: "",
                      itemStatusIsChecked: "",
                      itemStatusComment: "",
                      itemStatusCommentUser: "",
                      itemStatusCommentUserCurrent: "",
                      files: "",
                      media: [],
                      empCount: [],
                      projectReq: "",
                    },
                  ],
                  notapplicable: [],
                };

                return {
                  key: questionItem.key,
                  answerMstId: questionItem.responsetype,
                  isAnswerSubCat: false,
                  quesNo: questionItem.index,
                  value: questionItem.value,
                  options: questionItem.optionList,
                  responsetype: questionItem.responsetype,
                  questionSequenceNumber: questionItem.questionSequenceNumber,
                  radioSelectiovalue: "",
                  textValueQuestion: "",
                  singleSelect: 0,
                  multiSelect: [],
                  textAreaDetail: "",
                  files: "",
                  media: [],
                  responsData: dataForm,
                  isQuestionComplete: false,
                  isQuestionError: false,
                  isAnswerQuestion: false,
                  involvedPartyShow: questionItem?.isInvolvedParty,
                  isMandatory: !!questionItem?.isMandatory,
                };
              }),
          };
        },
      ),
    };
  });
};

export const formchangeHandler = async (
  targetValue,
  questionValue,
  subCategoryValue,
  categoryValue,
  targetName,
  notAppce,
  listInspectionCategory,
  setListInspectionCategory,
) => {
  const listInspectionCategoryClone = [...listInspectionCategory];

  listInspectionCategoryClone?.forEach((category) => {
    if (category?.key === categoryValue?.key) {
      category.listInspectionSubCategory?.forEach((subCategory) => {
        if (subCategoryValue?.key === subCategory?.key) {
          subCategory.listInspectionQuestionAnswer?.forEach((question) => {
            if (parseInt(question?.key) === parseInt(questionValue?.key)) {
              if (targetName === "radioSelectiovalue") {
                question.isAnswerQuestion = false;
              }
              if (targetName === "textAreaDetail") {
                const raw = typeof targetValue === "string" ? targetValue : "";
                const cleaned = cleanQuill(raw);
                question.textAreaDetail = raw;
                question.isAnswerSubCat = cleaned !== "";
                question.isAnswerQuestion = cleaned !== "";
              }

              if (targetName === "multiSelect") {
                question.multiSelect = Array.isArray(targetValue)
                  ? targetValue
                  : [];
                const answered =
                  Array.isArray(question.multiSelect) &&
                  question.multiSelect.length > 0;
                question.isAnswerSubCat = answered;
                question.isAnswerQuestion = answered;
              }

              if (targetName === "radioSelectiovalue") {
                question.radioSelectiovalue = targetValue;

                // Treat Acceptable (1), Not Acceptable (2) and N/A (3) as answered
                const answered =
                  parseInt(targetValue) === 1 ||
                  parseInt(targetValue) === 2 ||
                  parseInt(targetValue) === 3;

                question.isAnswerSubCat = answered;
                question.isAnswerQuestion = answered;
              }

              if (targetName === "singleSelect") {
                question.singleSelect = targetValue;
                const answered = Number.parseInt(targetValue) > 0;
                question.isAnswerSubCat = answered;
                question.isAnswerQuestion = answered;
              }

              if (targetName === "deleteKudos") {
                if (question?.responsData?.acceptable) {
                  question.responsData.acceptable =
                    question.responsData.acceptable.filter((notAcc) => {
                      return notAcc.id !== targetValue?.id;
                    });
                }
              }

              if (targetName === "deleteCorrective") {
                if (question?.responsData?.notacceptable) {
                  question.responsData.notacceptable =
                    question.responsData.notacceptable.filter((notAcc) => {
                      return notAcc.id !== targetValue?.id;
                    });
                }
              }

              if (targetName === "addcorrectiveitem") {
                question?.responsData?.notacceptable.push({
                  id: Date.now() + Math.floor(Math.random() * 100),
                  comment: "",
                  involdevPaty: "N/A",
                  employee: [],
                  employeeCurrent: "",
                  subcontractor: [],
                  subcontractorCurrent: "",
                  escalatetoreprimandIsChecked: "No",
                  escalatetoreprimandComment: "",
                  itemStatusIsChecked: "",
                  addAbatementNotes: "",
                  itemStatusCommentUser: "",
                  itemStatusCommentUserCurrent: "",
                  files: "",
                  media: [],
                  empCount: [],
                  projectReq: "",
                });
              }

              if (targetName === "kudos") {
                question?.responsData?.acceptable.push({
                  id: Date.now() + Math.floor(Math.random() * 100),
                  comment: "",
                  files: "",
                  media: [],
                  involdevPaty: "N/A",
                  employee: [],
                  employeeCurrent: "",
                  subcontractor: [],
                  subcontractorCurrent: "",
                  projectReq: "",
                });
              }
              question?.responsData?.acceptable?.forEach((notAcc) => {
                if (notAcc?.id === notAppce?.id) {
                  if (targetName === "comment") {
                    notAcc.comment = targetValue;
                  }
                  if (targetName === "involvedpartytype") {
                    notAcc.involdevPaty = targetValue;
                  }
                  if (targetName === "involvedpartyemployee") {
                    if (
                      targetValue &&
                      targetValue.key &&
                      !notAcc?.employee?.some(
                        (emp) =>
                          parseInt(emp.key) === parseInt(targetValue.key),
                      )
                    ) {
                      notAcc.employee.push(targetValue);
                      notAcc.employeeCurrent = "";
                      notAcc._errorInvolvedParty = null;
                    }
                  }
                  if (targetName === "deleteEmployee") {
                    notAcc.employee = notAcc.employee.filter((na) => {
                      return na.key !== targetValue;
                    });
                  }
                  if (targetName === "addinvolvedcompany") {
                    if (
                      targetValue &&
                      targetValue.key &&
                      !notAcc?.subcontractor?.some(
                        (sub) =>
                          parseInt(sub.key) === parseInt(targetValue.key),
                      )
                    ) {
                      notAcc.subcontractor.push(targetValue);
                      notAcc.subcontractorCurrent = "";
                      notAcc._errorInvolvedParty = null;
                    }
                  }
                  if (targetName === "deleteSubcontractor") {
                    notAcc.subcontractor = notAcc.subcontractor.filter((na) => {
                      return na.key !== targetValue;
                    });
                  }
                }
              });

              question?.responsData?.notacceptable?.forEach(async (notAcc) => {
                if (notAcc?.id === notAppce?.id) {
                  if (targetName === "comment") {
                    notAcc.comment = targetValue;
                    const cleanedComment = cleanQuill(targetValue || "");
                    if (cleanedComment && cleanedComment.trim()) {
                      notAcc._error = null;
                    }
                  }
                  if (targetName === "involvedpartytype") {
                    notAcc.involdevPaty = targetValue;
                  }
                  if (targetName === "involvedpartyemployee") {
                    if (
                      targetValue &&
                      targetValue.key &&
                      !notAcc?.employee?.some(
                        (emp) =>
                          parseInt(emp.key) === parseInt(targetValue.key),
                      )
                    ) {
                      notAcc.employee.push(targetValue);
                      notAcc.employeeCurrent = "";
                      notAcc._errorInvolvedParty = null;

                      const data = {
                        id: targetValue?.key,
                        organisationId: parseInt(ORG_ID()),
                        type: GET_COUNT_TYPE?.VIOLATION,
                      };
                      if (targetValue?.key) {
                        try {
                          const response = await getInspectionViolationCounts({
                            data,
                          });

                          if (response?.status === 200) {
                            const countResult = response?.data?.result;

                            notAcc.empCount = [
                              ...(notAcc.empCount || []),
                              {
                                count: countResult,
                                key: targetValue.key,
                              },
                            ];

                            setListInspectionCategory((prev) => {
                              const next = JSON.parse(JSON.stringify(prev));
                              next.forEach((cat) => {
                                cat.listInspectionSubCategory?.forEach(
                                  (sub) => {
                                    sub.listInspectionQuestionAnswer?.forEach(
                                      (q) => {
                                        q?.responsData?.notacceptable?.forEach(
                                          (na, idx) => {
                                            if (na.id === notAcc.id) {
                                              q.responsData.notacceptable[idx] =
                                                notAcc;
                                            }
                                          },
                                        );
                                      },
                                    );
                                  },
                                );
                              });
                              return next;
                            });
                          } else {
                            console.warn(
                              "Employee violation count fetch failed:",
                              response?.payload?.status,
                            );
                          }
                        } catch (err) {
                          console.error(
                            "Error fetching employee violation count:",
                            err,
                          );
                        }
                      }
                    }
                  }
                  if (targetName === "deleteEmployee") {
                    notAcc.employee = notAcc.employee.filter((na) => {
                      return na.key !== targetValue;
                    });
                    notAcc.empCount = notAcc.empCount.filter(
                      (items) => items.key !== targetValue,
                    );
                  }
                  if (targetName === "addinvolvedcompany") {
                    if (
                      targetValue &&
                      targetValue.key &&
                      !notAcc?.subcontractor?.some(
                        (sub) =>
                          parseInt(sub.key) === parseInt(targetValue.key),
                      )
                    ) {
                      notAcc.subcontractor.push(targetValue);
                      notAcc.subcontractorCurrent = "";
                      notAcc._errorInvolvedParty = null;

                      const data = {
                        id: targetValue?.key,
                        organisationId: parseInt(ORG_ID()),
                        type: GET_COUNT_TYPE?.VIOLATION,
                      };
                      if (targetValue?.key) {
                        try {
                          const response = await getInspectionViolationCounts({
                            data,
                          });

                          if (response?.status === 200) {
                            const countResult = response?.data?.result;

                            notAcc.empCount = [
                              ...(notAcc.empCount || []),
                              {
                                count: countResult,
                                key: targetValue.key,
                              },
                            ];
                            setListInspectionCategory((prev) => {
                              const next = JSON.parse(JSON.stringify(prev));
                              next.forEach((cat) => {
                                cat.listInspectionSubCategory?.forEach(
                                  (sub) => {
                                    sub.listInspectionQuestionAnswer?.forEach(
                                      (q) => {
                                        q?.responsData?.notacceptable?.forEach(
                                          (na, idx) => {
                                            if (na.id === notAcc.id) {
                                              q.responsData.notacceptable[idx] =
                                                notAcc;
                                            }
                                          },
                                        );
                                      },
                                    );
                                  },
                                );
                              });
                              return next;
                            });
                          } else {
                            console.warn(
                              "Employee violation count fetch failed:",
                              response?.payload?.status,
                            );
                          }
                        } catch (err) {
                          console.error(
                            "Error fetching employee violation count:",
                            err,
                          );
                        }
                      }
                    }
                  }
                  if (targetName === "deleteSubcontractor") {
                    notAcc.subcontractor = notAcc.subcontractor.filter(
                      (na) => na.key !== targetValue,
                    );
                    notAcc.empCount = notAcc.empCount.filter(
                      (items) => items.key !== targetValue,
                    );
                  }
                  if (targetName === "escalatetoreprimand") {
                    notAcc.escalatetoreprimandIsChecked = targetValue;
                  }
                  if (targetName === "escalatetoreprimandComment") {
                    notAcc.escalatetoreprimandComment = targetValue;
                  }
                  if (targetName === "itemStatus") {
                    notAcc.itemStatusIsChecked = targetValue;
                    if (targetValue) {
                      notAcc._errorItem = null;
                    }
                  }
                  if (targetName === "addabatementnotes") {
                    notAcc.addAbatementNotes = targetValue;
                  }
                  if (targetName === "assignitemresponsibility") {
                    notAcc.itemStatusCommentUser = targetValue;
                    notAcc.itemStatusCommentUserCurrent = "";
                  }
                  if (targetName === "deleteItemStatusCommentUser") {
                    notAcc.itemStatusCommentUser = "";
                    notAcc.itemStatusCommentUserCurrent = "";
                  }
                }
              });
            }
          });

          // ---------- REPLACED manual recalculation with recompute calls ----------
          // Recompute sub-category progress (handles skipped subcategories too)
          recomputeSubProgress(subCategory);

          // Recompute category progress (handles skipped category too)
          recomputeCategoryProgress(category);
        }
      });
    }
  });

  setListInspectionCategory(listInspectionCategoryClone);
};

export const fileUploadHandler = (
  files,
  single,
  questionValue,
  subCategoryValue,
  categoryValue,
  acc,
  action,
  listInspectionCategory,
  setListInspectionCategory,
) => {
  const listInspectionCategoryClone = [...listInspectionCategory];
  listInspectionCategoryClone?.forEach((category) => {
    if (category?.key === categoryValue?.key) {
      category.listInspectionSubCategory?.forEach((subCategory) => {
        if (subCategoryValue?.key === subCategory?.key) {
          subCategory.listInspectionQuestionAnswer?.forEach((question) => {
            if (parseInt(question?.key) === parseInt(questionValue?.key)) {
              if (action === "textbox") {
                if (!question.files) question.files = "";
                if (!question.media) question.media = [];

                if (files !== question.files) {
                  question.files = files;
                }
                if (Array.isArray(single)) {
                  single?.forEach((media) => {
                    if (!question.media?.includes(media)) {
                      question.media.push(media);
                    }
                  });
                }
                return;
              }
              const responseType =
                action === "acceptable" ? "acceptable" : "notacceptable";
              question?.responsData?.[responseType]?.forEach((notAcc) => {
                if (notAcc?.id === acc?.id) {
                  if (!notAcc.files) notAcc.files = "";
                  if (!notAcc.media) notAcc.media = "";

                  if (files !== notAcc.files) {
                    notAcc.files = files;
                  }
                  if (Array.isArray(single)) {
                    single?.forEach((media) => {
                      if (!notAcc.media?.includes(media)) {
                        notAcc.media.push(media);
                      }
                    });
                  }
                }
              });
            }
          });
        }
      });
    }
  });
  setListInspectionCategory(listInspectionCategoryClone);
};

export const deleteImageHandler = (
  urls,
  index,
  questionValue,
  subCategoryValue,
  categoryValue,
  acc,
  action,
  listInspectionCategory,
  setListInspectionCategory,
) => {
  const listInspectionCategoryClone = [...listInspectionCategory];

  listInspectionCategoryClone?.forEach((category) => {
    if (category?.key === categoryValue?.key) {
      category.listInspectionSubCategory?.forEach((subCategory) => {
        if (subCategoryValue?.key === subCategory?.key) {
          subCategory.listInspectionQuestionAnswer?.forEach((question) => {
            if (parseInt(question?.key) === parseInt(questionValue?.key)) {
              if (action === "textbox") {
                const filesArray = (question.files || "").split("|");
                const newFilesArray = filesArray.filter((url) => url !== urls);
                question.files = newFilesArray.join("|");
                if (Array.isArray(question.media)) {
                  question.media = question.media.filter((_, i) => i !== index);
                }
                return;
              }
              const responseType =
                action === "acceptable" ? "acceptable" : "notacceptable";
              question?.responsData?.[responseType]?.forEach((notAcc) => {
                if (notAcc?.id === acc?.id) {
                  const filesArray = notAcc.files.split("|");
                  const newFilesArray = filesArray.filter(
                    (url) => url !== urls,
                  );
                  notAcc.files = newFilesArray.join("|");
                  if (Array.isArray(notAcc.media)) {
                    notAcc.media = notAcc.media.filter((_, i) => i !== index);
                  }
                }
              });
            }
          });
        }
      });
    }
  });

  setListInspectionCategory(listInspectionCategoryClone);
};

export const mapListInspectionCategory = (listInspectionCategory) => {
  const result = [];

  listInspectionCategory?.forEach((x) => {
    const item = {
      isSkipped: x.isSkipped,
      categoryId: x.key,
      sequenceNumber: x.sequenceNumber,
    };
    item.listInspectionSubCategory = x.listInspectionSubCategory?.map((y) => {
      const subCategory = {
        isSkipped: y.isSkipped,
        subCategoryId: y.key,
        sequenceNumber: y.sequenceNumber,
      };
      subCategory.listInspectionQuestionAnswer =
        y.listInspectionQuestionAnswer?.map((z) => {
          const questionAnswer = {
            sequenceId: z.quesNo,
            answerMstId:
              parseInt(z.responsetype) === 1
                ? parseInt(z.radioSelectiovalue) === 1
                  ? QUESTION_ANSWER_RESPONSE_TYPE.ACCEPTABLE
                  : parseInt(z.radioSelectiovalue) === 2
                    ? QUESTION_ANSWER_RESPONSE_TYPE.NOTACCEPTABLE
                    : parseInt(z.radioSelectiovalue) === 3
                      ? QUESTION_ANSWER_RESPONSE_TYPE.NOTAPPLICABLE
                      : undefined
                : parseInt(z.responsetype) === 3
                  ? QUESTION_ANSWER_RESPONSE_TYPE.SINGLE_SELECT
                  : parseInt(z.responsetype) === 2
                    ? QUESTION_ANSWER_RESPONSE_TYPE.TEXTBOX
                    : parseInt(z.responsetype) === 4
                      ? QUESTION_ANSWER_RESPONSE_TYPE.MULTI_SELECT
                      : null,
            questionId: parseInt(z.key),
            isMandatory: z.isMandatory,
          };

          if (parseInt(z.responsetype) === 4) {
            questionAnswer.listInspectionQuestionAnswerDet = [
              {
                comment: z.multiSelect?.toString(),
              },
            ];
          } else if (parseInt(z.responsetype) === 3) {
            questionAnswer.listInspectionQuestionAnswerDet = [
              {
                comment: z.singleSelect?.toString(),
              },
            ];
          } else if (parseInt(z.responsetype) === 2) {
            questionAnswer.listInspectionQuestionAnswerDet = [
              {
                comment: z.textAreaDetail,
                correctiveFiles: z?.media,
                isCorrectiveFileAdded: z?.media?.length ? true : false,
              },
            ];
          } else if (parseInt(z.responsetype) === 1) {
            if (parseInt(z.radioSelectiovalue) === 1) {
              questionAnswer.listInspectionQuestionAnswerDet =
                z?.responsData?.acceptable?.map((detail) => {
                  const detailItem = {
                    comment: detail.comment,
                    correctiveFiles: detail?.media,
                    involvedPartyType:
                      detail?.involdevPaty === "Employee"
                        ? 0
                        : detail?.involdevPaty === "Sub-Contractor"
                          ? 1
                          : detail?.involdevPaty === "N/A"
                            ? 2
                            : 3,
                    isCorrectiveFileAdded: detail?.media?.length ? true : false,
                  };
                  detailItem.listInspectionInvolvedUsers =
                    detail?.involdevPaty === "Employee"
                      ? detail.employee
                          ?.map((emp) => {
                            if (emp) {
                              const InvolvedUsersItem = {
                                involvedUser: parseInt(emp.key),
                              };
                              return InvolvedUsersItem;
                            }
                            return null;
                          })
                          .filter((item) => item !== null)
                      : detail.subcontractor
                          ?.map((emp) => {
                            if (emp) {
                              const InvolvedUsersItem = {
                                involvedUser: parseInt(emp.key),
                              };
                              return InvolvedUsersItem;
                            }
                            return null;
                          })
                          .filter((item) => item !== null);
                  return detailItem;
                });
            } else if (parseInt(z.radioSelectiovalue) === 2) {
              questionAnswer.listInspectionQuestionAnswerDet =
                z?.responsData?.notacceptable?.map((detail) => {
                  const detailItem = {
                    issue: detail.comment,
                    isReprimand:
                      detail?.escalatetoreprimandIsChecked === "Yes"
                        ? true
                        : false,
                    actionTaken:
                      detail?.escalatetoreprimandIsChecked === "Yes"
                        ? detail.escalatetoreprimandComment
                        : "",
                    itemStatus: detail.itemStatusIsChecked === "Open" ? 2 : 3,
                    itemResponsibility:
                      detail.itemStatusIsChecked === "Open"
                        ? parseInt(detail?.itemStatusCommentUser?.key)
                        : 0,
                    abatementNotes:
                      detail.itemStatusIsChecked === "Closed"
                        ? detail?.addAbatementNotes
                        : "",
                    correctiveFiles: detail?.media,
                    involvedPartyType:
                      detail?.involdevPaty === "Employee"
                        ? 0
                        : detail?.involdevPaty === "Sub-Contractor"
                          ? 1
                          : detail?.involdevPaty === "N/A"
                            ? 2
                            : 3,
                    isCorrectiveFileAdded: detail?.media?.length ? true : false,
                  };
                  detailItem.listInspectionInvolvedUsers =
                    detail?.involdevPaty === "Employee"
                      ? detail.employee
                          ?.map((emp) => {
                            if (emp) {
                              const InvolvedUsersItem = {
                                involvedUser: parseInt(emp.key),
                              };
                              return InvolvedUsersItem;
                            }
                            return null;
                          })
                          .filter((item) => item !== null)
                      : detail.subcontractor
                          ?.map((emp) => {
                            if (emp) {
                              const InvolvedUsersItem = {
                                involvedUser: parseInt(emp.key),
                              };
                              return InvolvedUsersItem;
                            }
                            return null;
                          })
                          .filter((item) => item !== null);
                  return detailItem;
                });
            } else if (parseInt(z.radioSelectiovalue) === 3) {
              questionAnswer.listInspectionQuestionAnswerDet = [];
            }
          }
          return questionAnswer;
        });
      return subCategory;
    });
    result.push(item);
  });

  return result;
};

export const editListInspectionCategory = (
  listInspectionCategory,
  setListInspectionCategory,
) => {
  const listInspectionCategoryClone = listInspectionCategory?.map(
    (category) => {
      const categoryClone = {
        key: category.key,
        value: category.value,
        sequenceNumber: category.sequenceNumber,
        catError: false,
        isSkipped: category.skipped,
        isSkippable: category.isSkippable,
      };

      categoryClone.listInspectionSubCategory =
        category?.subcategoriesView?.map((subCategory) => {
          const questionsRaw = subCategory?.insQuesAnsReportView || [];

          let responsDataBuilder = (question) => {
            let responsData = {
              acceptable: [],
              notacceptable: [],
              notapplicable: [],
            };
            if (question.reprimands) {
              question.reprimands?.forEach((reprimand) => {
                const baseData = {
                  id: Date.now() + Math.floor(Math.random() * 100),
                  comment: reprimand.comment,
                  files: reprimand.correctiveFiles
                    ?.map((file) => file.filePath)
                    .join("|"),
                  media: reprimand.correctiveFiles?.map((file) => file.fileId),
                  involdevPaty:
                    reprimand.employee_type === 0
                      ? "Employee"
                      : reprimand.employee_type === 1
                        ? "Subcontractor"
                        : "N/A",
                  employee:
                    reprimand.employee_type === 0
                      ? reprimand.involved_Ids || []
                      : [],
                  subcontractor:
                    reprimand.employee_type === 1
                      ? reprimand.involved_Ids || []
                      : [],
                };

                if (
                  reprimand.answer_id ===
                  QUESTION_ANSWER_RESPONSE_TYPE.ACCEPTABLE
                ) {
                  responsData.acceptable.push(baseData);
                } else if (
                  reprimand.answer_id ===
                  QUESTION_ANSWER_RESPONSE_TYPE.NOTACCEPTABLE
                ) {
                  responsData.notacceptable.push({
                    ...baseData,
                    comment: reprimand.corrective_issue_dtl,
                    empCount: reprimand?.involved_Ids?.map((item) => ({
                      key: item.key,
                      count: item.count,
                    })),
                    escalatetoreprimandIsChecked: reprimand?.escalate_reprimand
                      ? "Yes"
                      : "No",
                    escalatetoreprimandComment: reprimand?.action_taken_dtl,
                    itemStatusIsChecked: reprimand?.item_status,
                    itemStatusComment: "",
                    itemStatusCommentUser: {
                      key: reprimand?.item_responsibility_id,
                      value: reprimand?.item_responsibility_name,
                    },
                    itemStatusCommentUserCurrent: "",
                    addAbatementNotes: reprimand?.abatement_notes,
                  });
                } else if (
                  reprimand.answer_id ===
                  QUESTION_ANSWER_RESPONSE_TYPE.NOTAPPLICABLE
                ) {
                  responsData.notacceptable = [];
                }
              });
            }
            return responsData;
          };

          const mappedQuestions = questionsRaw.map((question) => {
            const multiSelectVals =
              question.reprimands
                ?.find(
                  (r) =>
                    r.answer_id === QUESTION_ANSWER_RESPONSE_TYPE.MULTI_SELECT,
                )
                ?.comment?.split(",")
                ?.map((item) => item.trim())
                ?.filter(Boolean) || [];

            const singleSelectVal = parseInt(
              question.reprimands?.find(
                (r) =>
                  r.answer_id === QUESTION_ANSWER_RESPONSE_TYPE.SINGLE_SELECT,
              )?.comment,
            );

            const textboxReprimand = question.reprimands?.find(
              (r) => r.answer_id === QUESTION_ANSWER_RESPONSE_TYPE.TEXTBOX,
            );
            const rawText = textboxReprimand?.comment || "";

            const cleanedText = cleanQuill(rawText);
            const textAreaDetail = cleanedText || null;

            const mapped = {
              key: question.questionId,
              isMandatory: question.isMandatory,
              value: question.question,
              sequenceNumber: question.sequenceId,
              quesNo: question.sequenceId,
              responsetype: question.responsetype,
              answerMstId: question.answerMstId,
              isMandatory: !!question?.isMandatory,
              options: question.optionList,
              isQuestionError: false,
              involvedPartyShow: question.isInvolvedParty,
              multiSelect: multiSelectVals,
              singleSelect: Number.isNaN(singleSelectVal)
                ? null
                : singleSelectVal,
              textAreaDetail,
              files:
                textboxReprimand?.correctiveFiles
                  ?.map((file) => file.filePath)
                  .join("|") || "",
              media:
                textboxReprimand?.correctiveFiles?.map((file) => file.fileId) ||
                [],
              radioSelectiovalue: question.answerMstId,
              responsData: responsDataBuilder(question),
            };

            mapped.isAnswerQuestion = isAnswered(mapped);
            return mapped;
          });

          const totalQs = questionsRaw.length || 0;
          const answeredQs = mappedQuestions.filter(isAnswered).length;
          const isSubSkipped = !!subCategory.skipped;
          const subPercent = isSubSkipped
            ? totalQs
              ? 100
              : 0
            : totalQs
              ? (100 * answeredQs) / totalQs
              : 0;

          return {
            key: subCategory.key,
            value: subCategory.value,
            sequenceNumber: subCategory.sequenceNumber,
            subPercent,
            howManySub: isSubSkipped ? totalQs : answeredQs,
            isSkipped: subCategory.skipped,
            isSkippable: subCategory.isSkippable,
            isAnswerCat: isSubSkipped ? true : answeredQs > 0,
            subCatAns: isSubSkipped ? true : answeredQs > 0,
            listInspectionQuestionAnswer: mappedQuestions,
          };
        });

      const allMappedSubs = categoryClone.listInspectionSubCategory || [];

      if (category?.skipped) {
        allMappedSubs.forEach((sc) => {
          sc.isSkipped = true;
          const totalQs = sc.listInspectionQuestionAnswer?.length || 0;
          sc.subPercent = totalQs ? 100 : 0;
          sc.howManySub = totalQs;
          sc.isAnswerCat = true;
          sc.subCatAns = true;
        });
      }

      const completedSubsCount = allMappedSubs.filter(
        (sc) => sc.isSkipped || sc.isAnswerCat,
      ).length;

      categoryClone.catPercent = allMappedSubs.length
        ? (100 * completedSubsCount) / allMappedSubs.length
        : 0;

      categoryClone.howManyCat = completedSubsCount;

      categoryClone.catAns = completedSubsCount === allMappedSubs.length;

      return categoryClone;
    },
  );

  setListInspectionCategory(listInspectionCategoryClone);
};
export const editFieldValues = (
  headerFieldsInfoResponse,
  setFieldValues,
  setInspectionHederFields,
) => {
  headerFieldsInfoResponse?.forEach((headerField) => {
    if (headerFieldsInfoResponse?.length > 0) {
      headerFieldsInfoResponse?.forEach((matchingField) => {
        const responseType = parseInt(matchingField.responsetype);
        let newValue;
        if (parseInt(responseType) === 9 && HBNUser) {
          if (typeof matchingField?.ans === "string") {
            const jsonObject = JSON.parse(matchingField.ans);
            newValue = {
              key: jsonObject.key,
              value: jsonObject.ans,
            };
          }
        } else if (parseInt(responseType) === 9 && !HBNUser) {
          if (typeof matchingField?.ans === "string") {
            const jsonObjectNU = JSON.parse(matchingField.ans);
            newValue = jsonObjectNU.key;
          }
        } else if (responseType === 6 || responseType === 2) {
          newValue = matchingField.ans;
        } else if (responseType === 3) {
          newValue = matchingField.ans?.toString();
        } else if (responseType === 5) {
          newValue = matchingField.ans?.split(",");
        } else if (responseType === 10) {
          newValue = {
            key: matchingField.key,
            value: matchingField.ans,
          };
        } else if (responseType === 11) {
          const ansValue = matchingField.ans;
          newValue = ansValue;
        } else {
          newValue = matchingField.ans;
        }
        setFieldValues((prevFieldValues) => ({
          ...prevFieldValues,
          [matchingField.key]: newValue,
        }));
        let selectAsset = {};
        setInspectionHederFields((prevAnswers) => {
          const answers = Array.isArray(prevAnswers) ? prevAnswers : [];

          const newAnswer = {
            insTypeFieldId: matchingField.key,
            ans:
              responseType === 2
                ? getFormatedDate(headerField.value)
                : responseType === 3 || responseType === 10
                  ? headerField.value?.toString()
                  : responseType === 9 && HBNUser
                    ? JSON.stringify(newValue)
                    : responseType === 9 && !HBNUser
                      ? JSON.stringify(selectAsset)
                      : responseType === 11
                        ? newValue
                        : headerField.value?.toString(),
          };

          const uniqueAnswers = new Set(
            [...answers, newAnswer]?.map((answer) => JSON.stringify(answer)),
          );

          return Array.from(uniqueAnswers)?.map((answer) => JSON.parse(answer));
        });
      });
    }
  });
};

export const validateCategories = (listInspectionCategoryClone) => {
  let isError = false;

  listInspectionCategoryClone?.forEach((cat) => {
    if (!cat.isSkipped || cat.isSkipped === null) {
      const nonSkippedSubs = (cat.listInspectionSubCategory || []).filter(
        (s) => !s.isSkipped || s.isSkipped === null,
      );
      const catMandatoryQs = nonSkippedSubs.flatMap((s) =>
        (s.listInspectionQuestionAnswer || []).filter((q) => q?.isMandatory),
      );
      const catHasMandatory = catMandatoryQs.length > 0;
      const catAnyMandatoryAnswered = catMandatoryQs.some(
        (q) => q.isAnswerQuestion,
      );

      if (catHasMandatory && !catAnyMandatoryAnswered) {
        cat.catError = true;
        isError = true;
      } else {
        cat.catError = false;
      }
    }

    if (!cat.isSkipped || cat.isSkipped === null) {
      cat.listInspectionSubCategory?.forEach((sub) => {
        if (!sub.isSkipped || sub.isSkipped === null) {
          sub.listInspectionQuestionAnswer?.forEach((question) => {
            if (question?.isMandatory && !question.isAnswerQuestion) {
              question.isQuestionError = true;
              isError = true;
            } else {
              question.isQuestionError = false;
            }

            if (
              parseInt(question.responsetype) === 1 &&
              parseInt(question.radioSelectiovalue) === 2
            ) {
              const details = question?.responsData?.notacceptable || [];

              details.forEach((acc) => {
                acc._error = null;
                acc._errorInvolvedParty = null;
                const cleanedComment = cleanQuill(acc.comment || "");
                if (!cleanedComment || !cleanedComment.trim()) {
                  question.isQuestionError = true;
                  isError = true;
                  acc._error = "Issue Found is required.";
                }
                if (!acc.itemStatusIsChecked) {
                  question.isQuestionError = true;
                  isError = true;
                  acc._errorItem = acc._errorItem || "Item Status is required";
                }
                if (
                  acc.involdevPaty === "Employee" &&
                  !(acc.employee && acc.employee.length)
                ) {
                  question.isQuestionError = true;
                  isError = true;
                  acc._errorInvolvedParty = "Involved Employee is required.";
                } else if (
                  acc.involdevPaty === "Sub-Contractor" &&
                  !(acc.subcontractor && acc.subcontractor.length)
                ) {
                  question.isQuestionError = true;
                  isError = true;
                  acc._errorInvolvedParty = "Involved Company is required.";
                }
              });
            }

            if (
              parseInt(question.responsetype) === 1 &&
              parseInt(question.radioSelectiovalue) === 1
            ) {
              const details = question?.responsData?.acceptable || [];

              details.forEach((acc) => {
                acc._errorInvolvedParty = null;
                if (
                  acc.involdevPaty === "Employee" &&
                  !(acc.employee && acc.employee.length)
                ) {
                  question.isQuestionError = true;
                  isError = true;
                  acc._errorInvolvedParty = "Involved Employee is required.";
                } else if (
                  acc.involdevPaty === "Sub-Contractor" &&
                  !(acc.subcontractor && acc.subcontractor.length)
                ) {
                  question.isQuestionError = true;
                  isError = true;
                  acc._errorInvolvedParty = "Involved Company is required.";
                }
              });
            }
          });
        }
      });
    }
  });

  return isError;
};

// ---------- UPDATED toggleSkipCategory ----------
export const toggleSkipCategory = (
  e,
  setListInspectionCategory,
  listInspectionCategory,
  categoryIndex,
) => {
  e.stopPropagation();
  const newCategories = [...listInspectionCategory];
  const category = newCategories[categoryIndex];

  // Toggle category skip
  category.isSkipped = !category.isSkipped;

  // If category is now skipped, mark all child subcategories and their questions as skipped/completed
  if (category.listInspectionSubCategory && category.isSkipped) {
    category.listInspectionSubCategory.forEach((sub) => {
      sub.isSkipped = true;
      if (sub.listInspectionQuestionAnswer) {
        const totalQs = sub.listInspectionQuestionAnswer.length;
        sub.listInspectionQuestionAnswer.forEach((q) => {
          q.isAnswerQuestion = true;
          q.isAnswerSubCat = true;
        });
        sub.subPercent = totalQs ? 100 : 0;
        sub.howManySub = totalQs;
        sub.isAnswerCat = true;
        sub.subCatAns = true;
      }
    });

    // category level computed as fully completed
    category.catPercent = category.listInspectionSubCategory.length ? 100 : 0;
    category.howManyCat = category.listInspectionSubCategory.length;
    category.catAns = true;
  } else if (category.listInspectionSubCategory && !category.isSkipped) {
    // If unskipping category, reset subcategories' isSkipped to false only if they are skippable
    category.listInspectionSubCategory.forEach((sub) => {
      // do not override sub.isSkippable default state; only unset isSkipped flag
      sub.isSkipped = sub.isSkippable ? false : sub.isSkipped;
      // reset questions' auto-complete flags when unskipping
      if (sub.listInspectionQuestionAnswer) {
        sub.listInspectionQuestionAnswer.forEach((q) => {
          // Only reset the auto flags if the question isn't actually answered
          if (!isAnswered(q)) {
            q.isAnswerQuestion = false;
            q.isAnswerSubCat = false;
          }
        });
      }
      // Recompute each sub's progress
      recomputeSubProgress(sub);
    });

    // Recompute category progress
    recomputeCategoryProgress(category);
  }

  setListInspectionCategory(newCategories);
};

// ---------- UPDATED toggleSkipSubCategory ----------
export const toggleSkipSubCategory = (
  e,
  setListInspectionCategory,
  listInspectionCategory,
  categoryIndex,
  subCategoryIndex,
) => {
  e.stopPropagation();
  const newCategories = [...listInspectionCategory];

  if (newCategories[categoryIndex].isSkipped) {
    // If parent category is skipped, do nothing to individual sub toggles
    return;
  }

  const subCategory =
    newCategories[categoryIndex]?.listInspectionSubCategory[subCategoryIndex];

  if (subCategory) {
    // Toggle skip state
    subCategory.isSkipped = !subCategory.isSkipped;

    // When subcategory is skipped -> mark its questions as answered/completed
    // When un-skipped -> mark questions as not automatically answered (reset to false)
    if (subCategory.listInspectionQuestionAnswer) {
      subCategory.listInspectionQuestionAnswer.forEach((question) => {
        // mark both sub-answer flag and question-level answered flag
        question.isAnswerQuestion = !!subCategory.isSkipped;
        question.isAnswerSubCat = !!subCategory.isSkipped;
      });
    }

    // Recompute progress for this sub and its category
    recomputeSubProgress(subCategory);
    recomputeCategoryProgress(newCategories[categoryIndex]);
  }

  setListInspectionCategory(newCategories);
};

export const getAnswerValue = (
  responsetype,
  processedValue,
  selectAsset,
  HBNUser,
) => {
  switch (parseInt(responsetype)) {
    case 2:
      return getFormatedDate(processedValue);
    case 3:
      return processedValue?.target?.value;
    case 10:
      return processedValue?.key?.toString();
    case 9:
      return HBNUser
        ? JSON.stringify(processedValue)
        : JSON.stringify(selectAsset);
    case 11:
      return typeof processedValue === "string" ? processedValue : "";
    default:
      return processedValue?.toString();
  }
};

export const findValueByKeyWeather = (value, weather) => {
  const foundItem = weather?.find(
    (item) =>
      item?.value?.toLocaleLowerCase() === value?.toLocaleLowerCase() ||
      parseInt(item.key) === parseInt(value),
  );
  return foundItem ? foundItem?.value : "N/A";
};

export const getResponseTypeValue = (key) => {
  const item = QUESTION_RESPONSE_TYPE_VALUE?.find((entry) => entry.key === key);
  return item ? item.value : null;
};

export const SIGNOFF_METHOD_TYPE_ADMIN = {
  SIGNATURE: "SIGNATURE",
  CERTIFY_STATEMENT: "CERTIFY_STATEMENT",
  NA: "NA",
};

export const getSignoffMethodValue = (signoffMethods) => {
  const { SIGNATURE, CERTIFY_STATEMENT, NA } = signoffMethods;

  if (SIGNATURE && CERTIFY_STATEMENT) return 4;
  if (SIGNATURE) return 1;
  if (CERTIFY_STATEMENT) return 2;
  if (NA) return 3;

  return 0;
};

export const updateSignoffMethods = (setSignoffMethods, signoffMethod) => {
  switch (signoffMethod) {
    case 1:
      setSignoffMethods({
        SIGNATURE: true,
        CERTIFY_STATEMENT: false,
        NA: false,
      });
      break;
    case 2:
      setSignoffMethods({
        SIGNATURE: false,
        CERTIFY_STATEMENT: true,
        NA: false,
      });
      break;
    case 3:
      setSignoffMethods({
        SIGNATURE: false,
        CERTIFY_STATEMENT: false,
        NA: true,
      });
      break;
    case 4:
      setSignoffMethods({
        SIGNATURE: true,
        CERTIFY_STATEMENT: true,
        NA: false,
      });
      break;
    default:
      setSignoffMethods({
        SIGNATURE: false,
        CERTIFY_STATEMENT: false,
        NA: false,
      });
      break;
  }
};

export const getUniqueHeaderFields = (fields) => {
  const map = new Map();

  fields.forEach((item) => {
    const key = `${item.insTypeFieldId}-${item.insTypeFieldVerId}`;
    const existing = map.get(key);

    if (!existing || (item.ans && !existing.ans)) {
      map.set(key, item);
    }
  });

  return Array.from(map.values());
};

export const getUniqueCategories = (categories) => {
  const categoryMap = new Map();

  categories.forEach((cat) => {
    if (!categoryMap.has(cat.categoryId)) {
      categoryMap.set(cat.categoryId, {
        ...cat,
        listInspectionSubCategory: [],
        _subMap: new Map(),
      });
    }

    const existingCat = categoryMap.get(cat.categoryId);

    cat.listInspectionSubCategory.forEach((sub) => {
      if (!existingCat._subMap.has(sub.subCategoryId)) {
        existingCat._subMap.set(sub.subCategoryId, {
          ...sub,
          listInspectionQuestionAnswer: [],
          _questionMap: new Map(),
        });
      }

      const existingSub = existingCat._subMap.get(sub.subCategoryId);

      sub.listInspectionQuestionAnswer.forEach((q) => {
        if (!existingSub._questionMap.has(q.questionId)) {
          existingSub._questionMap.set(q.questionId, q);
        }
      });
    });
  });

  return Array.from(categoryMap.values()).map((cat) => {
    const subCategories = Array.from(cat._subMap.values()).map((sub) => ({
      ...sub,
      listInspectionQuestionAnswer: Array.from(sub._questionMap.values()),
    }));

    const { _subMap, ...cleanCat } = cat;

    return {
      ...cleanCat,
      listInspectionSubCategory: subCategories.map(
        ({ _questionMap, ...s }) => s,
      ),
    };
  });
};
